var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlas = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7717 5.17133C19.4669 4.8659 18.9723 4.86543 18.6669 5.1702L10.5524 13.2678C10.2478 13.5724 9.75218 13.5724 9.44698 13.2672L1.33312 5.1702C1.02769 4.86539 0.533077 4.8659 0.228233 5.17133C-0.0765326 5.47676 -0.0760247 5.97141 0.229366 6.27617L8.34269 14.3727C8.79976 14.8296 9.39995 15.0581 10.0002 15.0581C10.6001 15.0581 11.2002 14.8297 11.6567 14.3732L19.7706 6.27617C20.076 5.97141 20.0765 5.47676 19.7717 5.17133Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alas.6f757760.svg";
export { ForwardRef as ReactComponent };